import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { Body, Table } from "@clayui/core";
import ClayCard from "@clayui/card";
import ClayButton from "@clayui/button";
import ClayDropdown from "@clayui/drop-down";
import ClayIcon from "@clayui/icon";
import { Link } from "react-router-dom";
import { listManualSubmissionByYearAndQuarter } from "../../../api/nebManualSubmissionService";
import { downloadFile } from "../../../api/fileSystemService";
import useAuthStore from "../../../store/useAuthStore";
import { getAgencyByLiferayId } from "../../../api/nebAgencyService";
import { getDataProviderByAgencyId } from "../../../api/nebDataProviderService";

function ManualSubmissionAdmin() {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 10;
  const availableYears = Array.from({ length: 11 }, (_, i) =>
    (startYear + i).toString()
  );
  
  const availableQuarters = ["Q1", "Q2", "Q3", "Q4"]; 

  const [manualSubmissionList, setManualSubmissionList] = useState([]);
  const [selectedYear, setSelectedYear] = useState(
    availableYears[availableYears.length - 1]
  );
  const [selectedQuarter, setSelectedQuarter] = useState("Q1"); 
  const [activeYearDropdown, setActiveYearDropdown] = useState(false);
  const [activeQuarterDropdown, setActiveQuarterDropdown] = useState(false); 
  const [sortedList, setSortedList] = useState([]);
  const [dpName, setDpName] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await listManualSubmissionByYearAndQuarter(selectedYear, selectedQuarter);
        
        const updatedList = await Promise.all(
          result.map(async (submission) => {
            const agency = await getAgencyByLiferayId(submission.createdBy);
            const dp = await getDataProviderByAgencyId(agency.id);
            return { ...submission, dpName: dp.name, agencyName: agency.agencyName };
          })
        );
        
        setManualSubmissionList(updatedList);
      } catch (error) {
        console.log(error);
      }
    };
  
    fetchData();
  }, [selectedYear, selectedQuarter]);
  

  useEffect(() => {
    setSortedList(sortListByQuarter([...manualSubmissionList]));
  }, [manualSubmissionList]);

  const handleYearSelection = (year) => {
    setSelectedYear(year);
    setActiveYearDropdown(false);
  };

  const handleQuarterSelection = (quarter) => {
    setSelectedQuarter(quarter.replace("Q", ""));;
    setActiveQuarterDropdown(false);
  };

  const handleDownload = async (filePath) => {
    try {
      await downloadFile(filePath);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  const sortListByQuarter = (list) => {
    return list.filter(submission => submission.quarter === selectedQuarter)
               .sort((a, b) => parseInt(a.quarter) - parseInt(b.quarter));
  };

  return (
    <>
      <ClayCard className="mb-3" style={{ borderRadius: "20px" }}>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <div className="ml-0">
            <ClayCard.Description displayType="title" className="mb-0">
              <b>List of Submission</b>
            </ClayCard.Description>
          </div>

          <div className="d-flex ml-auto align-items-center">
            <span className="mr-2">Year:</span>
            <ClayDropdown
              trigger={
                <ClayButton displayType="secondary" className="mr-3">
                  {selectedYear}
                  <ClayIcon symbol="caret-bottom" className="ml-2" />
                </ClayButton>
              }
              active={activeYearDropdown}
              onActiveChange={setActiveYearDropdown}
            >
              <ClayDropdown.ItemList>
                {availableYears.map((year, index) => (
                  <ClayDropdown.Item
                    key={index}
                    onClick={() => handleYearSelection(year)}
                  >
                    {year}
                  </ClayDropdown.Item>
                ))}
              </ClayDropdown.ItemList>
            </ClayDropdown>

            <span className="mr-2">Quarter:</span>
            <ClayDropdown
              trigger={
                <ClayButton displayType="secondary">
                  {selectedQuarter}
                  <ClayIcon symbol="caret-bottom" className="ml-2" />
                </ClayButton>
              }
              active={activeQuarterDropdown}
              onActiveChange={setActiveQuarterDropdown}
            >
              <ClayDropdown.ItemList>
                {availableQuarters.map((quarter, index) => (
                  <ClayDropdown.Item
                    key={index}
                    onClick={() => handleQuarterSelection(quarter)}
                  >
                    {quarter}
                  </ClayDropdown.Item>
                ))}
              </ClayDropdown.ItemList>
            </ClayDropdown>
          </div>
        </Card.Header>

        <Card.Body className="p-3" style={{ overflowX: "auto" }}>
          {sortedList.length === 0 ? (
            <p>No submissions found for this year and quarter.</p>
          ) : (
            <Table>
              <thead className="text-dark">
                <tr>
                  <th>Quarter</th>
                  <th>Form</th>
                  <th>Data Provider</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {sortedList.map((submission) => (
                  <tr key={submission.id}>
                    <td>{submission.quarter}</td>
                    <td>{submission.fileName}</td>
                    <td>{submission.agencyName}</td>
                    <td>
                      <Link
                        className="btn btn-link"
                        onClick={() =>
                          handleDownload(
                            `${submission.filePath.replace(/\\/g, "/")}/${
                              submission.fileName
                            }`
                          )
                        }
                      >
                        Download
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </ClayCard>
    </>
  );
}

export default ManualSubmissionAdmin;
